const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  loginName: state => state.user.loginName,
  nickName: state => state.user.nickName,
  adminId: state => state.user.adminId,
  ipId: state => state.user.ipId,
  ipStatus: state => state.user.ipStatus,
  roleId: state => state.user.roleId,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  menus: state => state.user.menus,
  alreayGeneraterMenus: state => state.permission.alreayGeneraterMenus
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js